import React from 'react'
import {
  USER_INFO,
} from '../../../configs/auth'
import { useNavigate } from 'react-router-dom'
import ListKitchen from '../../../components/organisms/admin/kitchen/ListKitchen'

type Props = {}

const ListKitchenPage = (props: Props) => {
  const navigate = useNavigate()

  const auth = JSON.parse(localStorage.getItem(USER_INFO) ?? "");
  const isSupperAdmin = auth?.roles.includes("SUPER_ADMIN");
  const isAdmin = auth?.roles.includes("ADMIN");
  const kitchenId = auth?.kitchen_id;

  if (isAdmin && kitchenId) {
    navigate(`/admin/editKitchen/${kitchenId}`);
  }

  return (
    isSupperAdmin && <ListKitchen />
  )
}

export default ListKitchenPage